export type AskResponse = {
    answer: string;
    citations: Citation[];
    error?: string;
    message_id?: string;
    feedback?: Feedback;
};

export type Citation = {
    part_index?: number;
    content: string;
    id: string;
    title: string | null;
    filepath: string | null;
    url: string | null;
    metadata: string | null;
    chunk_id: string | null;
    reindex_id: string | null;
}

export type ToolMessageContent = {
    citations: Citation[];
    intent: string;
}

export enum Assessments {
    Identity_Security = "Identity Security",
    Data_Security = "Data Security",
    AI_Readiness = "AI Readiness",
}

export enum Assessments_IDs {
    Identity_Security = "c49401bf-4e80-43ba-a3a3-64e6024ef188",
    Data_Security = "f946be50-ba28-4fa7-b088-ea3d4eecf15b",
    AI_Readiness = "0de07b8f-6e67-4f72-9450-46cca58ee35f",
}

export enum MessageType {
    Text = "Text",
    Options = "Options",
    ConsultationForm = "ConsultationForm",
}

export enum FlowType {
    AskForEmail = "AskForEmail",
    ConversationStarter = "ConversationStarter",
    Chat = "Chat",
    Chatend = "Chatend",
    Error = "Error",
    IdentityAssessment = "IdentityAssessment",
    DataAssessment = "DataAssessment",
    AIAssessment = "AIAssessment",
    AssessmentQuestion = "AssessmentQuestion",
    FinalScore = "FinalScore",
    AssessmentHelper = "AssessmentHelper",
}

export type ChatMessage = {
    id: string;
    role: string;
    content: string;
    end_turn?: boolean;
    date: string;
    feedback?: Feedback;
    context?: string;
    flowtype: string | FlowType;
    messageType: MessageType;
    messageInfo?: any;
};

export type Conversation = {
    id: string;
    title: string;
    messages: ChatMessage[];
    date: string;
}

export enum ChatCompletionType {
    ChatCompletion = "chat.completion",
    ChatCompletionChunk = "chat.completion.chunk"
}

export type ChatResponseChoice = {
    messages: ChatMessage[];
}

export type ChatResponse = {
    id: string;
    model: string;
    created: number;
    object: ChatCompletionType;
    choices: ChatResponseChoice[];
    history_metadata: {
        conversation_id: string;
        title: string;
        date: string;
    }
    error?: any;
}

export type ConversationRequest = {
    messages: ChatMessage[];
};

export type UserInfo = {
    access_token: string;
    expires_on: string;
    id_token: string;
    provider_name: string;
    user_claims: any[];
    user_id: string;
};

export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    InvalidCredentials = "CosmosDB has invalid credentials",
    InvalidDatabase = "Invalid CosmosDB database name",
    InvalidContainer = "Invalid CosmosDB container name",
    Working = "CosmosDB is configured and working",
}

export enum AssessmentStarterSystemMessagge {
    IdentityAssessmentSystemStarter = "Sure, let’s start the Identity Security Review Assessment. We will be assessing your organization’s security posture across six areas: Business Alignment, Access Control, Security Operations, Asset Protection, Security Governance, and Innovation Security. For each area, I will ask you a question to evaluate your organization’s readiness for cloud adoption and enhance structure, vendor selection and management, and data management practices. Are you ready to begin?",
    DataAssessmentSystemStarter = "Sure, let’s start the Data Security Review Assessment. We will be assessing your organization’s security posture across six areas: Business Alignment, Access Control, Security Operations, Asset Protection, Security Governance, and Innovation Security. For each area, I will ask you a question to evaluate your organization’s readiness for cloud adoption and enhance structure, vendor selection and management, and data management practices. Are you ready to begin?",
    AIAssessmentSystemStarter = "Sure, let’s start the AI Rediness Review Assessment. We will be assessing your organization’s security posture across six areas: Business Alignment, Access Control, Security Operations, Asset Protection, Security Governance, and Innovation Security. For each area, I will ask you a question to evaluate your organization’s readiness for cloud adoption and enhance structure, vendor selection and management, and data management practices. Are you ready to begin?",
}

export type CosmosDBHealth = {
    cosmosDB: boolean,
    status: string
}

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export type ErrorMessage = {
    title: string,
    subtitle: string
}

export type UI = {
    title: string;
    chat_title: string;
    chat_description: string;
    logo?: string;
    chat_logo?: string;
    show_share_button?: boolean
}

export type FrontendSettings = {
    auth_enabled?: string | null;
    feedback_enabled?: string | null;
    ui?: UI;
    sanitize_answer?: boolean;
}

export enum Feedback {
    Neutral = "neutral",
    Positive = "positive",
    Negative = "negative",
    MissingCitation = "missing_citation",
    WrongCitation = "wrong_citation",
    OutOfScope = "out_of_scope",
    InaccurateOrIrrelevant = "inaccurate_or_irrelevant",
    OtherUnhelpful = "other_unhelpful",
    HateSpeech = "hate_speech",
    Violent = "violent",
    Sexual = "sexual",
    Manipulative = "manipulative",
    OtherHarmful = "other_harmlful"
}